<template>
  <v-container>
    <!-- Main Title -->
    <h1
      class="display-1 font-weight-bold mb-4"
      style="color: #1976D2;"
    >
      Notification
    </h1>
    <!-- Main container with dotted border -->
    <div class="dotted-container">
      <!-- Tabs for navigation -->
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="primary"
        grow
      >
        <v-tab>
          <v-icon left>
            mdi-send-outline
          </v-icon>
          ສ້າງແຈ້ງເຕືອນ
        </v-tab>
        <v-tab>
          <v-icon left>
            mdi-clock-time-three-outline
          </v-icon>
          ລາຍການຕັ້ງເວລາແຈ້ງເຕືອນ
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <!-- Tab 1: Create Notification Form -->
        <v-tab-item>
          <v-card
            flat
            class="mt-5"
          >
            <v-card-text>
              <h2
                class="titlem b-6"
                style="color: #1976D2;"
              >
                ສ້າງການແຈ້ງເຕືອນໃໝ່
              </h2>
              <v-form
                ref="form"
                v-model="valid"
              >
                <!-- Notification Title -->
                <label class="font-weight-bold">ຫົວຂໍ້ການແຈ້ງເຕືອນ <span class="red--text">*</span></label>
                <v-text-field
                  v-model="notification.title"
                  placeholder="ປ້ອນຊື່ຫົວຂໍ້"
                  solo
                  flat
                  background-color="#f5f5f5"
                  class="mt-2"
                  :rules="[v => !!v || 'Title is required']"
                  required
                />
                <!-- Notification Details -->
                <label class="font-weight-bold mt-4 d-block">ລາຍລະອຽດ <span class="red--text">*</span></label>
                <v-textarea
                  v-model="notification.body"
                  placeholder="ປ້ອນລາຍລະອຽດ"
                  solo
                  flat
                  background-color="#f5f5f5"
                  class="mt-2"
                  rows="5"
                  no-resize
                  :rules="[v => !!v || 'Details are required']"
                  required
                />
                <!-- Sending Options -->
                <v-radio-group
                  v-model="notification.sendOption"
                  class="mt-4"
                >
                  <!-- Option 1: Send Immediately -->
                  <v-radio
                    value="success"
                    color="primary"
                  >
                    <template #label>
                      <div class="font-weight-bold">
                        ສົ່ງແຈ້ງເຕືອນທັນທີ
                      </div>
                    </template>
                  </v-radio>
                  <div class="radio-sub-label mb-3">
                    (ແຈ້ງເຕືອນຈະຖືກສົ່ງທັນທີຫຼັງຈາກກົດສົ່ງ)
                  </div>
                  <!-- Option 2: Schedule -->
                  <v-radio
                    value="pending"
                    color="primary"
                  >
                    <template #label>
                      <div class="font-weight-bold">
                        ຕັ້ງເວລາສົ່ງແຈ້ງເຕືອນ
                      </div>
                    </template>
                  </v-radio>
                  <div class="radio-sub-label">
                    (ສາມາດຕັ້ງວັນເວລາສົ່ງແຈ້ງເຕືອນໄດ້)
                  </div>
                </v-radio-group>
                <!-- Conditional Date and Time Pickers -->
                <div v-if="notification.sendOption === 'pending'">
                  <label class="font-weight-bold">ຊ່ວງວັນເວລາສົ່ງແຈ້ງເຕືອນ</label>
                  <v-row>
                    <!-- Date Picker -->
                    <v-col
                      cols="12"
                      sm="6"
                    >
                      <v-menu
                        ref="dateMenu"
                        v-model="dateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            :value="formattedDate"
                            placeholder="DD/MM/YY"
                            solo
                            flat
                            readonly
                            background-color="#f5f5f5"
                            prepend-inner-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="date"
                          no-title
                          @input="dateMenu = false"
                        />
                      </v-menu>
                    </v-col>
                    <!-- Time Picker -->
                    <v-col
                      cols="12"
                      sm="6"
                    >
                      <v-dialog
                        ref="datetimeDialog"
                        v-model="datetimeDialog"
                        persistent
                        max-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="time"
                            label="ວັນເວລາ"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          />
                        </template>
                        <v-card>
                          <v-time-picker v-model="time" />
                          <v-card-actions>
                            <v-btn
                              text
                              @click="datetimeDialog = false"
                            >
                              OK
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-col>
                  </v-row>
                </div>
              </v-form>
            </v-card-text>
            <v-btn
              block
              x-large
              color="primary"
              class="mt-8 font-weight-bold"
              style="text-transform: none; font-size: 18px;"
              @click="submit"
            >
              <v-icon left>
                mdi-send
              </v-icon>
              ສົ່ງແຈ້ງເຕືອນ
            </v-btn>
          </v-card>
        </v-tab-item>
        <!-- Tab 2: Scheduled List (Placeholder) -->
        <v-tab-item>
          <v-card
            flat
            class="mt-5 pa-5"
          >
            <v-card-title class="justify-space-between">
              <h3
                style="color:#1976D2;"
              >
                ລາຍການແຈ້ງເຕືອນທີ່ຕັ້ງເວລາ
              </h3>
              <v-btn
                small
                color="primary"
                :loading="loadingList"
                @click="fetchScheduled()"
              >
                <v-icon left>
                  mdi-refresh
                </v-icon>Refresh
              </v-btn>
            </v-card-title>

            <v-data-table
              :headers="scheduledHeaders"
              :items="scheduled"
              :loading="loadingList"
              class="elevation-1"
              disable-pagination
              hide-default-footer
              dense
            >
              <template v-slot:item.datetime="{ item }">
                <div>
                  <div>{{ item.date_sent || '-' }} {{ item.time_at || '' }}</div>
                  <div class="grey--text text--darken-1 caption">
                    {{ item.status }}
                  </div>
                </div>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  small
                  color="primary"
                  @click="openEdit(item)"
                >
                  <v-icon small>
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  small
                  color="error"
                  @click="confirmDelete(item)"
                >
                  <v-icon small>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>

            <div
              v-if="!scheduled.length && !loadingList"
              class="text-center grey--text mt-6"
            >
              <v-icon
                size="50"
                color="grey"
              >
                mdi-clock-time-three-outline
              </v-icon>
              <p class="mt-4 title">
                No scheduled notifications yet.
              </p>
            </div>
          </v-card>

          <!-- Edit Dialog -->
          <v-dialog
            v-model="editDialog"
            max-width="520px"
            persistent
          >
            <v-card>
              <v-card-title class="font-weight-bold">
                ແກ້ໄຂການແຈ້ງເຕືອນ
              </v-card-title>
              <v-card-text>
                <v-form
                  ref="editForm"
                  v-model="editValid"
                >
                  <v-text-field
                    v-model="editItem.title"
                    label="ຫົວຂໍ້ *"
                    :rules="[rules.required]"
                    outlined
                    dense
                  />
                  <v-textarea
                    v-model="editItem.body"
                    label="ລາຍລະອຽດ *"
                    :rules="[rules.required]"
                    outlined
                    dense
                    rows="4"
                  />

                  <!-- Date -->
                  <label class="font-weight-bold">ວັນທີ *</label>
                  <v-menu
                    v-model="editDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290"
                    min-width="auto"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        :value="formatDisplayDate(editItem.date_sent)"
                        readonly
                        outlined
                        dense
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        :rules="[rules.required]"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="editItem.date_sent"
                      @input="editDateMenu = false"
                    />
                  </v-menu>

                  <!-- Time -->
                  <label class="font-weight-bold mt-4 d-block">ເວລາ *</label>
                  <v-menu
                    v-model="editTimeMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290"
                    min-width="auto"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        :value="formatDisplayTime(editItem.time_at)"
                        readonly
                        outlined
                        dense
                        prepend-inner-icon="mdi-clock-outline"
                        v-bind="attrs"
                        :rules="[rules.required]"
                        v-on="on"
                      />
                    </template>
                    <v-time-picker
                      v-if="editTimeMenu"
                      v-model="editTimeRaw"
                      format="24hr"
                      full-width
                      @click:minute="applyEditTime()"
                    />
                  </v-menu>

                  <!-- Status -->
                  <v-select
                    v-model="editItem.status"
                    :items="['pending','success']"
                    label="ສະຖານະ"
                    outlined
                    dense
                  />
                  <small class="grey--text">pending = scheduled, success = send now</small>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  text
                  @click="closeEdit()"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="saving"
                  @click="saveEdit()"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Delete confirm -->
          <v-dialog
            v-model="deleteDialog"
            max-width="420px"
          >
            <v-card>
              <v-card-title class="font-weight-bold">
                ຢືນຢັນການລຶບ?
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  text
                  @click="deleteDialog=false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="error"
                  :loading="deleting"
                  @click="doDelete()"
                >
                  Delete
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'NotificationTab',
  data() {
    return {
      // list
      scheduled: [],
      loadingList: false,

      // edit
      editDialog: false,
      editValid: false,
      editItem: {
        id: null,
        title: '',
        body: '',
        status: 'pending',
        date_sent: null, // 'YYYY-MM-DD'
        time_at: null, // 'HH:mm:ss'
      },
      editDateMenu: false,
      editTimeMenu: false,
      editTimeRaw: null, // 'HH:mm' from picker
      saving: false,

      // delete
      deleteDialog: false,
      deleting: false,
      deleteId: null,

      // table headers
      scheduledHeaders: [
        { text: 'ຫົວຂໍ້', value: 'title' },
        { text: 'ລາຍລະອຽດ', value: 'body' },
        { text: 'ວັນທີ/ເວລາ', value: 'datetime' },
        {
          text: '', value: 'actions', sortable: false, align: 'end', width: 120,
        },
      ],

      rules: {
        required: (v) => !!v || 'Required',
      },
      tab: 0, // Active tab index
      valid: false, // Form validation state
      datetimeDialog: false,
      notification: {
        title: '',
        body: '',
        sendOption: 'success', // Default radio button selection
      },
      date: null,
      time: null,
      dateMenu: false,
      timeMenu: false,
    };
  },
  created() {
  // load the list when user visits Tab 2 directly
    this.fetchScheduled();
  },
  watch: {
  // whenever user switches to Tab 2, refresh
    tab(val) {
      if (val === 1) this.fetchScheduled();
    },
  },
  computed: {
    formattedDate() {
      if (!this.date) return null;
      const [year, month, day] = this.date.split('-');
      return `${day}/${month}/${year}`;
    },
  },

  methods: {
    formatDisplayDate(ymd) {
      if (!ymd) return '';
      const [y, m, d] = ymd.split('-');
      return `${d}/${m}/${y}`;
    },
    formatDisplayTime(hms) {
      if (!hms) return '';
      const [h, m] = hms.split(':');
      return `${h}:${m}`;
    },
    hhmmToHhmmss(t) {
      if (!t) return null;
      return t.length === 5 ? `${t}:00` : t;
    },
    // LOAD
    async fetchScheduled() {
      this.loadingList = true;
      try {
        const res = await this.$axios.get('customer-notification', { params: { status: 'pending' } });
        // Expecting array: [{id,title,body,status,date_sent,time_at,...}]
        this.scheduled = Array.isArray(res.data?.data) ? res.data.data : (res.data?.data?.data || []);
      } catch (e) {
        console.error(e);
        this.scheduled = [];
      } finally {
        this.loadingList = false;
      }
    },

    // EDIT
    openEdit(item) {
      this.editItem = {
        id: item.id,
        title: item.title,
        body: item.body,
        status: item.status || 'pending',
        date_sent: item.date_sent, // 'YYYY-MM-DD'
        time_at: item.time_at, // 'HH:mm:ss'
      };
      // seed raw time for picker
      this.editTimeRaw = this.editItem.time_at ? this.editItem.time_at.slice(0, 5) : null;
      this.editDialog = true;
    },
    applyEditTime() {
      this.editItem.time_at = this.hhmmToHhmmss(this.editTimeRaw);
      this.editTimeMenu = false;
    },
    closeEdit() {
      this.editDialog = false;
      this.$nextTick(() => {
        this.editItem = {
          id: null, title: '', body: '', status: 'pending', date_sent: null, time_at: null,
        };
        this.editTimeRaw = null;
      });
    },
    async saveEdit() {
      if (!this.$refs.editForm.validate()) return;

      // if status is pending, require date/time
      if (this.editItem.status === 'pending' && (!this.editItem.date_sent || !this.editItem.time_at)) {
        this.$store?.commit?.('Toast_State', { value: true, color: 'error', msg: 'Please set date & time' });
        return;
      }

      this.saving = true;
      try {
        const payload = {
          title: this.editItem.title,
          body: this.editItem.body,
          status: this.editItem.status, // 'pending' | 'success'
          date_sent: this.editItem.date_sent, // required if pending
          time_at: this.editItem.time_at, // required if pending
        };
        await this.$axios.put(`customer-notification/${this.editItem.id}`, payload);
        this.$store?.commit?.('Toast_State', { value: true, color: 'success', msg: 'Updated' });
        this.closeEdit();
        this.fetchScheduled();
      } catch (e) {
        console.error(e);
        this.$store?.commit?.('Toast_State', { value: true, color: 'error', msg: e.response?.data?.message || 'Update failed' });
      } finally {
        this.saving = false;
      }
    },

    // DELETE
    confirmDelete(item) {
      this.deleteId = item.id;
      this.deleteDialog = true;
    },
    async doDelete() {
      if (!this.deleteId) return;
      this.deleting = true;
      try {
        await this.$axios.delete(`customer-notification/${this.deleteId}`);
        this.$store?.commit?.('Toast_State', { value: true, color: 'success', msg: 'Deleted' });
        this.deleteDialog = false;
        this.fetchScheduled();
      } catch (e) {
        console.error(e);
        this.$store?.commit?.('Toast_State', { value: true, color: 'error', msg: e.response?.data?.message || 'Delete failed' });
      } finally {
        this.deleting = false;
      }
    },
    async submit() {
      if (!this.$refs.form.validate()) {
        alert('ກະລຸນາເຕີມຂໍ້ມູນໃນຟ້ອມກ່ອນ');
        return;
      }
      const { title, body, sendOption } = this.notification;

      // Base payload
      const payload = { title, body, status: sendOption }; // 'success' | 'pending'

      // If scheduling, require date+time and map to API keys
      if (sendOption === 'pending') {
        if (!this.date || !this.time) {
          alert('Please select both date and time');
          return;
        }
        payload.date_sent = this.date; // e.g. "2025-09-20"
        payload.time_at = this.hhmmToHhmmss(this.time); // "14:10:00"
      }

      try {
        const res = await this.$axios.post('customer-notification', payload);

        // log safely
        console.log('data:', res?.data);

        if (res?.data?.code === 200) {
          // try to read status from response; fallback to what you sent
          const status = res?.data?.data?.status || res?.data?.status || this.notification.sendOption;

          if (status === 'pending') {
            alert('ຕັ້ງການແຈ້ງເຕືອນສຳເລັດ'); // scheduled
          } else {
            alert('ແຈ້ງເຕືອນສົ່ງສຳເລັດ'); // sent now
          }

          // reset form
          this.notification.title = '';
          this.notification.body = '';
          this.notification.sendOption = 'success';
          this.date = null;
          this.time = null;
          this.$refs.form.resetValidation?.();

          return; // done
        }

        // non-200 from API
        this.$store?.commit?.('Toast_State', {
          value: true,
          color: 'error',
          msg: res?.data?.message || 'Send failed',
        });
      } catch (error) {
        console.error(error);
        this.$store?.commit?.('Toast_State', {
          value: true,
          color: 'error',
          msg: error.response?.data?.message || 'Network error',
        });
      }
    },
  },
};
</script>

<style>
.dotted-container {
  border: 2px dashed #42A5F5;
  border-radius: 12px;
  padding: 20px;
  background-color: #FFFFFF;
}

.v-tab {
  text-transform: none !important;
  font-size: 16px !important;
  font-weight: 500;
}

.form-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.radio-sub-label {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  margin-top: -4px;
  margin-left: 32px;
}</style>
